export function updateStateItemInList(getList: () => any[], fetchItem: (list: any[]) => any, updateItem: (item: any) => void) {
    const list = getList();
    const { index, item } = fetchItem(list);
    updateItem(item);
    list[index] = item;
  }
export function updateStateItem(fetchItem: ()  => any, updateItem: (item: any) => void) {
    const item = fetchItem();
    updateItem(item);
  }